import { Editor } from '../../../Components/Common/Editor'
import { cap } from '../../../State'
import { translations } from '../../../translations'
const language = cap.language.state || 'IT'
const t = translations[language]

export const Editors = ({
  checkMeteo,
  quotesMessage: [quotesMessage, setQuotesMessage],
  selectedSteps,
  initialMessages
}) => {
  if (selectedSteps !== '2') return null

  return (
    <div className="nsec" style={{ marginBottom: 16 }}>
      <div className="nsec__head">
        <div className="nsec__ico">
          <i className="pi pi-envelope" style={{ fontSize: 16 }} />
        </div>
        <h3 className="nsec__title">{t.messaggioPreventivi}</h3>
      </div>
      <div className="nsec__body">
        <div className="nfield" style={{ marginBottom: 12 }}>
          <label>{t.messaggioLink}</label>
          <div className="nfield__hint">{t.messaggioLinkPreventivi}</div>
          {checkMeteo && <div className="nfield__hint">{t.messaggioMeteo}</div>}
        </div>
        <Editor
          id="quotesMessage"
          onChange={({ quotesMessage: changedQuotesMessage }) =>
            changedQuotesMessage.trim() !== quotesMessage.trim() &&
            setQuotesMessage(changedQuotesMessage)
          }
          initialValue={initialMessages.quotesMessage || ''}
        />
      </div>
    </div>
  )
}
